module.exports = __webpack_public_path__ + "static/Creator 15 - @KingGeorge-9c435bb7f10e1c2d68053695b92a0781.png";